var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
var Props = (function () {
    function Props() {
    }
    return Props;
}());
;
var SubComponent = (function (_super) {
    __extends(SubComponent, _super);
    function SubComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.displayName = 'SubComponent';
        return _this;
    }
    SubComponent.prototype.componentDidMount = function () {
        this.context.centralizedUpdates(this);
    };
    SubComponent.prototype.componentDidUpdate = function () {
        this.context.centralizedUpdates(this);
    };
    SubComponent.prototype.render = function () {
        return null;
    };
    SubComponent.contextTypes = {
        centralizedUpdates: PropTypes.func
    };
    return SubComponent;
}(React.Component));
;
var Coord = (function (_super) {
    __extends(Coord, _super);
    function Coord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Coord';
        return _this;
    }
    return Coord;
}(SubComponent));
export { Coord };
var Guide = (function (_super) {
    __extends(Guide, _super);
    function Guide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Guide';
        return _this;
    }
    return Guide;
}(SubComponent));
export { Guide };
var Axis = (function (_super) {
    __extends(Axis, _super);
    function Axis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Axis';
        return _this;
    }
    return Axis;
}(SubComponent));
export { Axis };
var Geom = (function (_super) {
    __extends(Geom, _super);
    function Geom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Series';
        return _this;
    }
    return Geom;
}(SubComponent));
export { Geom };
var Tooltip = (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Tooltip';
        return _this;
    }
    return Tooltip;
}(SubComponent));
export { Tooltip };
var Legend = (function (_super) {
    __extends(Legend, _super);
    function Legend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'Legend';
        return _this;
    }
    return Legend;
}(SubComponent));
export { Legend };
//# sourceMappingURL=SubComponent.js.map